const model = {
    name: 'Personalization',
    properties: {
        algorithm: {},
        fields: { type: 'array' },
        ids: { type: 'array' },
    },
};
export default model;
